import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';
import { MODAL_IDS } from 'types/modal';

const getModalReducer = (state: RootState) => state.modalReducer;
const isModalOpen = (modalId: MODAL_IDS) => createSelector(getModalReducer, (res) => res.currentModal === modalId);

export const modalSelector = { isModalOpen };
